import { render, staticRenderFns } from "./crudDownloads.vue?vue&type=template&id=fe0015a0"
import script from "./crudDownloads.vue?vue&type=script&lang=js"
export * from "./crudDownloads.vue?vue&type=script&lang=js"
import style0 from "./crudDownloads.vue?vue&type=style&index=0&id=fe0015a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports